// extracted by mini-css-extract-plugin
module.exports = {"resume-card":"MyIntegrationResume_resume-card__g36LA","whitelabelButton":"MyIntegrationResume_whitelabelButton__gNGUx"};